import { defineComponent as _defineComponent } from 'vue'
import { getPrettyCurrentDate } from '@@/bits/date'
import { n__ } from '@@/bits/intl'
import { transformCurrentUrl } from '@@/bits/location'
import { isRegistered } from '@@/bits/user_model'
import OzBadge, { OzBadgeColorScheme, OzBadgeSizePreset } from '@@/library/v4/components/OzBadge.vue'
import OzBaseButton from '@@/library/v4/components/OzBaseButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzRelativeTime from '@@/library/v4/components/OzRelativeTime.vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfaceFreezePadletPanel } from '@@/pinia/surface_freeze_padlet_panel'
import { useSurfacePermissionsStore } from '@@/pinia/surface_permissions'
import { useSurfacePostsStore } from '@@/pinia/surface_posts'
import { useSurfaceUserContributorsStore } from '@@/pinia/surface_user_contributors'
import { uniqBy } from 'lodash-es'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceBuilder',
  setup(__props) {

const surfaceStore = useSurfaceStore()
const {
  builder,
  backgroundLuminance,
  colorScheme,
  isFrozen,
  isMap,
  skinAccentColorAsRGB,
  skinAccentTextColor,
  wallUpdatedAt,
  isTemplate,
  isMobileLayout,
} = storeToRefs(surfaceStore)

const { showContributorsList } = useSurfaceUserContributorsStore()

const surfacePostsStore = useSurfacePostsStore()
const { postEntities } = storeToRefs(surfacePostsStore)

const surfaceFreezePadletPanelStore = useSurfaceFreezePadletPanel()
const { showSurfaceFreezePadletPanel } = surfaceFreezePadletPanelStore

const surfacePermissionsStore = useSurfacePermissionsStore()
const { canIAdminister } = storeToRefs(surfacePermissionsStore)

const isSkinColorAvailable = computed<boolean>(() => {
  return !!skinAccentColorAsRGB.value && !!skinAccentTextColor.value
})

const bgColorScheme = computed<'light' | 'dark'>(() => {
  return isMap.value && !isMobileLayout.value ? colorScheme.value : backgroundLuminance.value
})

const isBuilderRegistered = computed<boolean>(() => {
  return isRegistered(builder.value)
})

const builderProfileUrl = computed<string>(() => {
  return transformCurrentUrl({}, { path: builder.value.username })
})

const contributorCount = computed<number>(() => {
  const nonBuilderAuthorPosts = postEntities.value.filter((p) => p.author_id !== builder.value.id)
  return uniqBy(nonBuilderAuthorPosts, 'author_id').length
})

const contributorText = computed<string>(() => {
  return n__('%{num} contributor', '%{num} contributors', contributorCount.value, { num: contributorCount.value })
})

return { __sfc: true,surfaceStore, builder, backgroundLuminance, colorScheme, isFrozen, isMap, skinAccentColorAsRGB, skinAccentTextColor, wallUpdatedAt, isTemplate, isMobileLayout, showContributorsList, surfacePostsStore, postEntities, surfaceFreezePadletPanelStore, showSurfaceFreezePadletPanel, surfacePermissionsStore, canIAdminister, isSkinColorAvailable, bgColorScheme, isBuilderRegistered, builderProfileUrl, contributorCount, contributorText, getPrettyCurrentDate, OzBadge, OzBadgeColorScheme, OzBadgeSizePreset, OzBaseButton, OzIcon, OzRelativeTime }
}

})